// extracted by mini-css-extract-plugin
export default {"textField":"textField---qAfKc","copyControl":"copyControl---t3vRf"};